
import React from 'react';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Home'
import { Cart } from './Components/Cart';
import LogIn from './Pages/LogIn';
import Product from './Pages/Product';
import AboutUs from './Pages/AboutUs';
import SignUp from './Pages/SignUp';
import Profile from './Pages/Profile';
import Footer from './Components/Footer/Footer';
import PetFood from './Pages/PetFood';
import DogProducts from './Pages/dogProducts';
import CatProducts from './Pages/catProducts';
import ContactUs from './Pages/ContactUs';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ShippingDelivery from './Pages/ShippingDelivery';
import TermsConditions from './Pages/TermsConditions';
import { Checkout } from './Components/Cart';
import { CartProvider, useCart } from './Components/Cart'
import { AuthProvider } from './Context/AuthContext'

const CartToast = () => {
  const { notification, dismissNotification } = useCart()
  if (!notification) return null
  return (
    <div className="cart-toast">
      <span>{notification}</span>
      <button onClick={dismissNotification} className="cart-toast-close">&times;</button>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
    <CartProvider>
    <CartToast />
    <div className="app-layout">
      <BrowserRouter>

        <Navbar />
        <main className="app-content">
        <Routes>

          <Route path='/' element={<Home />} />
          <Route path='/AboutUs' element={<AboutUs />} />
          <Route path='/PetFood' element={<PetFood />} />
          <Route path='/CatFood' element={<PetFood category="cat_food" />} />
          <Route path='/DogProducts' element={<DogProducts />} />
          <Route path='/CatProducts' element={<CatProducts />} />

          <Route path='/Product' element={<Product />}>
            <Route path=':productID' element={<Product />} />
          </Route>

          <Route path='/Cart' element={<Cart />} />

          <Route path='/LogIn' element={<LogIn />} />
          <Route path='/SignUp' element={<SignUp />} />

          <Route path='/ContactUs' element={<ContactUs />} />
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
          <Route path='/ShippingDelivery' element={<ShippingDelivery />} />
          <Route path='/TermsConditions' element={<TermsConditions />} />
          <Route path='/Checkout' element={<Checkout />} />
          <Route path='/Profile' element={<Profile />} />

        </Routes>
        </main>

        <Footer />

      </BrowserRouter>
    </div>
    </CartProvider>
    </AuthProvider>
  );
}

export default App;
